import moment from "moment";
import { globals, page as pageIndex, RegsTypes } from "../../globals";
import { logOut } from "./auth";
import { formatDate } from "./formatDate";
import { populateSortAndSearchParams } from "./helpers";
import { showModal } from "./modal";
import { actionHandler, UPDATE_DATA } from "./updateData";

// ------------------------------------
// Constants
// ------------------------------------
export const REGS_NRR_OPEN_RECORD_START = "REGS_NRR_OPEN_RECORD_START";
export const REFRESH_RECORDS = "REFRESH_RECORDS";
export const UPDATE_REVIEW_DATA = "UPDATE_REVIEW_DATA";
export const GET_QUERIES_LIST_START = "GET_QUERIES_LIST_START";
export const GET_REGS_NRR_QUERY_DATA_START = "GET_REGS_NRR_QUERY_DATA_START";
export const GET_REGS_NRR_QUERY_DATA_SUCCESS =
  "GET_REGS_NRR_QUERY_DATA_SUCCESS";
export const GET_REGS_NRR_QUERY_DATA_FAILURE =
  "GET_REGS_NRR_QUERY_DATA_FAILURE";
export const GET_TEAM_REVIEW_DATA_START = "GET_TEAM_REVIEW_DATA_START";
export const GET_TEAM_REVIEW_DATA_SUCCESS = "GET_TEAM_REVIEW_DATA_SUCCESS";
export const GET_TEAM_REVIEW_DATA_FAILURE = "GET_TEAM_REVIEW_DATA_FAILURE";
export const SET_TEAMS_REVIEW_DATA_START = "SET_TEAMS_REVIEW_DATA_START";
export const SET_TEAMS_REVIEW_DATA_SUCCESS = "SET_TEAMS_REVIEW_DATA_SUCCESS";
export const SET_TEAMS_REVIEW_DATA_FAILURE = "SET_TEAMS_REVIEW_DATA_FAILURE";
export const GET_TEAM_REVIEW_OPTIONS_DATA_START =
  "GET_TEAM_REVIEW_OPTIONS_DATA_START";
export const GET_TEAM_REVIEW_OPTIONS_DATA_SUCCESS =
  "GET_TEAM_REVIEW_OPTIONS_DATA_SUCCESS";
export const GET_TEAM_REVIEW_OPTIONS_DATA_FAILURE =
  "GET_TEAM_REVIEW_OPTIONS_DATA_FAILURE";
export const GET_REGETL_START = "GET_REGETL_START";
export const GET_REGETL_SUCCESS = "GET_REGETL_SUCCESS";
export const GET_REGETL_FAILURE = "GET_REGETL_FAILURE";
export const GET_REGETL_KEYWORDS_START = "GET_REGETL_KEYWORDS_START";
export const GET_REGETL_KEYWORDS_SUCCESS = "GET_REGETL_KEYWORDS_SUCCESS";
export const GET_REGETL_KEYWORDS_FAILURE = "GET_REGETL_KEYWORDS_FAILURE";
export const GET_REGETL_CLIENT_SUBJECTS_START =
  "GET_REGETL_CLIENT_SUBJECTS_START";
export const GET_REGETL_CLIENT_SUBJECTS_SUCCESS =
  "GET_REGETL_CLIENT_SUBJECTS_SUCCESS";
export const GET_REGETL_CLIENT_SUBJECTS_FAILURE =
  "GET_REGETL_CLIENT_SUBJECTS_FAILURE";
export const GET_REGETL_REG_START = "GET_REGETL_REG_START";
export const GET_REGETL_REG_SUCCESS = "GET_REGETL_REG_SUCCESS";
export const GET_REGETL_REG_FAILURE = "GET_REGETL_REG_FAILURE";
export const GET_REGETL_REGS_TYPE_START = "GET_REGETL_REGS_TYPE_START";
export const GET_REGETL_REGS_TYPE_SUCCESS = "GET_REGETL_REGS_TYPE_SUCCESS";
export const GET_REGETL_REGS_TYPE_FAILURE = "GET_REGETL_REGS_TYPE_FAILURE";
export const GET_REGETL_LOAD_OPTIONS_START = "GET_REGETL_LOAD_OPTIONS_START";
export const GET_REGETL_LOAD_OPTIONS_SUCCESS =
  "GET_REGETL_LOAD_OPTIONS_SUCCESS";
export const GET_REGETL_LOAD_OPTIONS_FAILURE =
  "GET_REGETL_LOAD_OPTIONS_FAILURE";
export const CLEAR_FIELD_FOR_NO_RESULTS = "CLEAR_FIELD_FOR_NO_RESULTS";
export const RETURN_REGS_RECORD_REVIEW_INITIAL_STATE =
  "RETURN_REGS_RECORD_REVIEW_INITIAL_STATE";
export const OPEN_RECORD_SUCCESS = "OPEN_RECORD_SUCCESS";
export const SET_ID_REVIEWED_START = "SET_ID_REVIEWED_START";
export const SET_ID_REVIEWED_FAILURE = "SET_ID_REVIEWED_FAILURE";
export const SET_ID_REVIEWED_SUCCESS = "SET_ID_REVIEWED_SUCCESS";
export const GET_HIGHLIGHTED_DOC_START = "GET_HIGHLIGHTED_DOC_START";
export const GET_HIGHLIGHTED_DOC_FAILURE = "GET_HIGHLIGHTED_DOC_FAILURE";
export const GET_HIGHLIGHTED_DOC_SUCCESS = "GET_HIGHLIGHTED_DOC_SUCCESS";
export const LOAD_TO_NEW_REG_START = "LOAD_TO_NEW_REG_START";
export const LOAD_TO_NEW_REG_FAILURE = "LOAD_TO_NEW_REG_FAILURE";
export const LOAD_TO_NEW_REG_SUCCESS = "LOAD_TO_NEW_REG_SUCCESS";
export const GET_REG_LOAD_OPTIONS_START = "GET_REG_LOAD_OPTIONS_START";
export const GET_REG_LOAD_OPTIONS_FAILURE = "GET_REG_LOAD_OPTIONS_FAILURE";
export const GET_REG_LOAD_OPTIONS_SUCCESS = "GET_REG_LOAD_OPTIONS_SUCCESS";
export const GET_INITIAL_DATA_START = "GET_INITIAL_DATA_START";
export const GET_INITIAL_DATA_COMPLETE = "GET_INITIAL_DATA_COMPLETE";
export const LOAD_TO_EXISTING_REG_START = "LOAD_TO_EXISTING_REG_START";
export const LOAD_TO_EXISTING_REG_FAILURE = "LOAD_TO_EXISTING_REG_FAILURE";
export const LOAD_TO_EXISTING_REG_SUCCESS = "LOAD_TO_EXISTING_REG_SUCCESS";
export const SET_TITLE_EDIT = "SET_TITLE_EDIT";
export const GET_REGETL_CITATIONMATCH_START = "GET_REGETL_CITATIONMATCH_START";
export const GET_REGETL_CITATIONMATCH_SUCCESS = "GET_REGETL_CITATIONMATCH_SUCCESS";
export const GET_REGETL_CITATIONMATCH_FAILURE = "GET_REGETL_CITATIONMATCH_FAILURE";


const headers = {
  "Content-Type": "application/json",
};

export function getRegNRRInitialState() {
  return initialState;
}

function formatDateShort(date) {
  return date && date !== "" ? moment(date).format("MM/DD/YYYY") : "";
}

function matchReviewRows(rows) {
  return rows.map((item) => {
    return {
      textValues: {
        team: item.Team || "",
        assignedBy: item.AssignedBy || "",
        assignedDate: formatDate(item.AssignedDate),
        reviewedBy: item.ReviewedBy || "",
        reviewedDate: formatDate(item.ReviewedDate),
        type: Object.keys(RegsTypes).find(
          (key) => RegsTypes[key] === String(item.FlagType)
        ),
        flag: String(item.FlagType),
      },
      isReviewed: item.ReviewedBy !== null,
    };
  });
}

function matchRecordInfo(info) {
  return {
    textValues: {
      id: info.Id || "",
      type: info.RegsTypeValue || "",
      state: info.State || "",
      agency: info.AgencyName || "",
      actionDate: formatDate(info.ActionDate),
      title: info.Title || "",
      summary: info.Summary || "",
      url: info.SourceUrl || "",
      citations: info.Tags.map((tag) => {
        return {
          textValues: {
            citationName: tag.CitationName,
            citationValue: tag.TagValue,
            citationId: tag.Id,
          },
        };
      }),
      contact: info.ContactInfo || "",
      sspath: info.SSPath || "",
      recordCreated: formatDate(info.CreateDate),
      regsId: info.RelatedRegs.map((reg) => {
        return reg.RegsId;
      }),
      year: info.Year || "",
      teams: info.Teams || "",
      regETLSubType: info.RegETLSubtype || "",
      regETLType: info.RegETLType || "",
      regsTypeId: info.RegsTypeId || "",
      regsTypeValue: info.RegsTypeValue || "",
      toolboxURL: info.ToolboxUrl || "",
      documents: info.Urls
        ? info.Urls.map((doc) => {
            return {
              url: doc.Url,
              description: doc.Description,
              urlType: doc.Type,
            };
          })
        : [],
      llartsnote:  info.LLARTSNote || "",
    },
  };
}

function matchIderInfo(info) {
  return {
    textValues: {
      ider: info.IDer || "",
      iderReviewed: info.IDerReviewed || "",
      iderReviewedDate: formatDate(info.IDerReviewedDate),
    },
  };
}

function matchKeywordHits(hits) {
  return hits.map((hit) => {
    return {
      textValues: {
        team: hit.Team || "",
        client: hit.Client || "",
        grouping: hit.Subject || "",
        keyword: hit.Keyword || "",
        hits: hit.Hits,
        foundDate: formatDate(hit.FoundDate),
        changeDate: formatDate(hit.ChangeDate),
        oldHits: hit.OldHits,
        keywordId: hit.KeywordId,
        taggingInstructions: hit.GroupTaggingInstructions || "",
        description: hit.GroupDescription || "",
        overview: hit.GroupOverview || "",
        boolPhrase: hit.BoolPhrase,
        groupingId: hit.GroupingId,
      },
    };
  });
}

function matchClientSubjects(clients) {
  return clients.map((client) => {
    return {
      textValues: {
        deleted: client.DeleteIt || false,
        client: client.ClientName || "",
        clientDescription: client.ClientDescription || "",
        subject: client.Subject || "",
        subjectDescription: client.SubjectDescription || "",
        changeDate: formatDate(client.CreateDate),
        user: client.CreateUserId || "",
      },
    };
  });
}

function matchSimilarRegs(regs) {
  return regs.map((reg) => {
    return {
      textValues: {        
        regsId: reg.RegsId || "",
        title: reg.Title || "",
        lastUpdateDate: reg.LastUpdateDate ? formatDateShort(reg.LastUpdateDate) : formatDateShort(reg.CreateDate),
      },
    };
  });
}

function getLoadToRegRequest(recordInfo) {
  return {
    id: recordInfo.id,
    state: recordInfo.state,
    title: recordInfo.title,
    summary: recordInfo.summary,
    regsTypeId: recordInfo.regsTypeId,
    year: recordInfo.year,
    contactInfo: recordInfo.contact,
    actionDate: recordInfo.actionDate,
    teams: recordInfo.teams,
    agencyName: recordInfo.agency,
    regETLSubtype: recordInfo.regsTypeValue,
    loadConfig: {
      options: [],
    },
  };
}

function getLoadToExistingRegRequest(recordInfo, regInfo, options) {
  return {
    id: recordInfo.id,
    state: recordInfo.state,
    title: regInfo.Title,
    summary: regInfo.Summary,
    regsTypeId: recordInfo.regsTypeId,
    year: regInfo.Year,
    contactInfo: regInfo.OfficialContact,
    actionDate: recordInfo.actionDate,
    teams: recordInfo.teams,
    agencyName: recordInfo.agency,
    regETLSubtype: recordInfo.regETLSubType,
    loadConfig: {
      options: options,
      RegId: regInfo.RegId,
    },
  };
}

const getReviewData = (regETLId) => {
  return (dispatch) =>
    Promise.all([
      dispatch(getRegEtl(regETLId)),
      dispatch(getRegETLTeamReview(regETLId)),
      dispatch(getRegEtlKeywords(regETLId)),
      dispatch(getRegEtlClientSubjects(regETLId)),
      // dispatch(getRegEtlCitationMatch(regETLId)),
    ])
};

export function openReviewRecord(regETLId) {
  return (dispatch) => {
    dispatch({ type: REGS_NRR_OPEN_RECORD_START });
    dispatch(getReviewData(regETLId, dispatch)).finally(() => {
      dispatch({ type: OPEN_RECORD_SUCCESS, payload: { regETLId } });
    });
    dispatch(getRegEtlCitationMatch(regETLId));
  };
}

const getInitialData = () => {
  return (dispatch) =>
    Promise.all([dispatch(getRegsNRR()), dispatch(getLoadOptions())]);
};

export function loadInitialData() {
  return (dispatch) => {
    dispatch({ type: GET_INITIAL_DATA_START });
    dispatch(getInitialData()).finally(() => {
      dispatch({ type: GET_INITIAL_DATA_COMPLETE });
    });
  };
}

export function getRegsNRR() {
  return (dispatch) => {
    dispatch({ type: GET_REGS_NRR_QUERY_DATA_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RegsNRR`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_REGS_NRR_QUERY_DATA_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGS_NRR_QUERY_DATA_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        dispatch({ type: GET_REGS_NRR_QUERY_DATA_FAILURE, json: err.message });
      });
  };
}

export function getLoadOptions() {
  return (dispatch) => {
    dispatch({ type: GET_REG_LOAD_OPTIONS_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RegETL/LoadOptions`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_REG_LOAD_OPTIONS_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REG_LOAD_OPTIONS_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        dispatch({ type: GET_REG_LOAD_OPTIONS_FAILURE, json: err.message });
        dispatch(showModal("Error"));
      });
  };
}

export function postRegsNRR(regsUrlsParameters) {
  return (dispatch) => {
    dispatch({ type: GET_TEAM_REVIEW_OPTIONS_DATA_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify(regsUrlsParameters),
    };
    return fetch(`${globals.apiUrl}/RegsNRR`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_TEAM_REVIEW_OPTIONS_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          const queryRecords = json;

          dispatch({
            type: GET_TEAM_REVIEW_OPTIONS_DATA_SUCCESS,
            payload: {
              queryRecords,
            },
          });
          if (queryRecords.length > 0) {
            dispatch(openReviewRecord(queryRecords[0]));
            dispatch(getLoadOptions());
          } else {
            dispatch(showModal("No-results"));
            dispatch(clearFormFields());
          }
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_TEAM_REVIEW_OPTIONS_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getRegETLTeamReview(id) {
  return (dispatch) => {
    dispatch({ type: GET_TEAM_REVIEW_DATA_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RegETL/TeamReview/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_TEAM_REVIEW_DATA_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_TEAM_REVIEW_DATA_SUCCESS,
            payload: {
              json,
              id,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_TEAM_REVIEW_DATA_FAILURE, json: err.message });
      });
  };
}

export function postRegETLTeamsReview(id, teams, reviewed) {
  return (dispatch) => {
    dispatch({ type: SET_TEAMS_REVIEW_DATA_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        regETLId: id,
        teams: teams,
        reviewed: reviewed,
      }),
    };
    return fetch(`${globals.apiUrl}/RegETL/TeamsReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: SET_TEAMS_REVIEW_DATA_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SET_TEAMS_REVIEW_DATA_SUCCESS,
            payload: {
              json,
              id,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SET_TEAMS_REVIEW_DATA_FAILURE, json: err.message });
      });
  };
}

export function getRegEtl(id) {
  return (dispatch) => {
    dispatch({ type: GET_REGETL_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RegETL/GetRegETL/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_REGETL_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGETL_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_REGETL_FAILURE, json: err.message });
      });
  };
}

export function postIdReviewed(id) {
  return (dispatch) => {
    dispatch({ type: SET_ID_REVIEWED_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: id,
    };
    return fetch(`${globals.apiUrl}/RegETL/IdReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: SET_ID_REVIEWED_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SET_ID_REVIEWED_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SET_ID_REVIEWED_FAILURE, json: err.message });
      });
  };
}

export function postLoadToNewReg(recordInfo) {
  return (dispatch) => {
    dispatch({ type: LOAD_TO_NEW_REG_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify(getLoadToRegRequest(recordInfo.textValues)),
    };
    return fetch(`${globals.apiUrl}/RegETL/Load`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: LOAD_TO_NEW_REG_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((regId) => {
        if (regId) {
          dispatch({
            type: LOAD_TO_NEW_REG_SUCCESS,
            payload: {
              regId,
            },
          });

          return regId;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: LOAD_TO_NEW_REG_FAILURE, json: err.message });
      });
  };
}

export function postLoadToExistingReg(recordInfo, regInfo, mergeOptions) {
  return (dispatch) => {
    dispatch({ type: LOAD_TO_EXISTING_REG_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify(
        getLoadToExistingRegRequest(
          recordInfo.textValues,
          regInfo,
          mergeOptions
        )
      ),
    };
    return fetch(`${globals.apiUrl}/RegETL/LoadExisting`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: LOAD_TO_EXISTING_REG_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((regId) => {
        if (regId) {
          dispatch({
            type: LOAD_TO_EXISTING_REG_SUCCESS,
            payload: {
              regId,
            },
          });

          return regId;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: LOAD_TO_EXISTING_REG_FAILURE, json: err.message });
      });
  };
}

export function getRegEtlKeywords(id) {
  return (dispatch) => {
    dispatch({ type: GET_REGETL_KEYWORDS_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RegETL/GetKeywords/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_REGETL_KEYWORDS_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGETL_KEYWORDS_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_REGETL_KEYWORDS_FAILURE, json: err.message });
      });
  };
}

export function getRegEtlCitationMatch(id) {
  return (dispatch) => {
    dispatch({ type: GET_REGETL_CITATIONMATCH_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RegETL/GetRegETLCitationMatch/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_REGETL_CITATIONMATCH_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGETL_CITATIONMATCH_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_REGETL_CITATIONMATCH_FAILURE, json: err.message });
      });
  };
}

export function getRegEtlClientSubjects(id) {
  return (dispatch) => {
    dispatch({ type: GET_REGETL_CLIENT_SUBJECTS_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RegETL/GetClientSubjects/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_REGETL_CLIENT_SUBJECTS_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGETL_CLIENT_SUBJECTS_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_REGETL_CLIENT_SUBJECTS_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getHighlightedDocument(teams, keywords, path) {
  return (dispatch) => {
    dispatch({ type: GET_HIGHLIGHTED_DOC_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/KeywordHits`);

    const params = {
      docpath: path,
      service: "regs",
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    if (teams && teams.length != 0) {
      teams.forEach((team) => {
        if (String(team).length > 0) {
          url.searchParams.append("teamId", team);
        }
      });
    }

    if (keywords && keywords.length != 0) {
      keywords.forEach((keyword) =>
        url.searchParams.append("keywordId", keyword)
      );
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.url;
        } else if (response.status === 302) {
          return response.url;
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_HIGHLIGHTED_DOC_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((url) => {
        if (url) {
          dispatch({
            type: GET_HIGHLIGHTED_DOC_SUCCESS,
            payload: {
              url,
            },
          });
          return url;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_HIGHLIGHTED_DOC_FAILURE,
          json: "Highlighting document: " + err.message,
        });
        dispatch(showModal("Error"));
      });
  };
}

export function getRegTypes() {
  return (dispatch) => {
    dispatch({ type: GET_REGETL_REGS_TYPE_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    fetch(`${globals.apiUrl}/RegETL/GetRegsTypes`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_REGETL_REGS_TYPE_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGETL_REGS_TYPE_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_REGETL_REGS_TYPE_FAILURE, json: err.message });
      });
  };
}

export function getReg(id) {
  return (dispatch) => {
    dispatch({ type: GET_REGETL_REG_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RegETL/GetReg/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_REGETL_REG_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGETL_REG_SUCCESS,
            payload: {
              json,
            },
          });

          return json;
        } else {
          dispatch({
            type: GET_REGETL_REG_FAILURE,
            json: "Reg ID " + id + " is invalid!",
          });
          dispatch(showModal("Error"));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_REGETL_REG_FAILURE, json: err.message });
      });
  };
}

export function clearFormFields() {
  return {
    type: CLEAR_FIELD_FOR_NO_RESULTS,
  };
}

export function returnInitialState() {
  return {
    type: RETURN_REGS_RECORD_REVIEW_INITIAL_STATE,
  };
}

export function setTitle(id, title){
  return (dispatch) => {
    dispatch({ type: SET_TITLE_EDIT, payload: { json: title } });
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA]: (state, action) =>
    action.location.page !== pageIndex.regsNewRecordReview
      ? state
      : actionHandler(state, action),
  [RETURN_REGS_RECORD_REVIEW_INITIAL_STATE]: () => {
    return {
      ...initialState,
    };
  },
  [GET_REGS_NRR_QUERY_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_REGS_NRR_QUERY_DATA_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        queriesWithParameters: json,
        queries: json.map((item) => {
          return {
            value: item.QueryId,
            label: item.QueryName,
          };
        }),
      },
    };
  },
  [GET_TEAM_REVIEW_OPTIONS_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_TEAM_REVIEW_OPTIONS_DATA_SUCCESS]: (state, action) => {
    const queryRecords = action.payload.queryRecords;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        queryRecords,
      },
    };
  },
  [GET_TEAM_REVIEW_OPTIONS_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_TEAM_REVIEW_DATA_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_TEAM_REVIEW_DATA_SUCCESS]: (state, action) => {
    const recordsData = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RNRR: {
          ...state.formDataValue.RNRR,
          reviewRecords: matchReviewRows(recordsData),
        },
      },
    };
  },
  [GET_TEAM_REVIEW_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [SET_TEAMS_REVIEW_DATA_START]: (state) => {
    return {
      ...state,
    };
  },
  [SET_TEAMS_REVIEW_DATA_SUCCESS]: (state, action) => {
    const recordsData = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RNRR: {
          ...state.formDataValue.RNRR,
          reviewRecords: matchReviewRows(recordsData),
        },
      },
    };
  },
  [SET_TEAMS_REVIEW_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_QUERIES_LIST_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_REGETL_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_REGETL_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_REGETL_SUCCESS]: (state, action) => {
    const recordInfo = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RNRR: {
          ...state.formDataValue.RNRR,
          recordInfo: matchRecordInfo(recordInfo),
          iderReviewedInfo: matchIderInfo(recordInfo),
        },
      },
    };
  },
  [GET_INITIAL_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_INITIAL_DATA_COMPLETE]: (state) => {
    return {
      ...state,
      isFetchingData: false,
    };
  },
  [REGS_NRR_OPEN_RECORD_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [OPEN_RECORD_SUCCESS]: (state, action) => {
    const currentIndex = state.renderData.queryRecords.findIndex(
      (record) => record === action.payload.regETLId
    );
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        RNRR: {
          ...state.formDataValue.RNRR,
          currentRegETLId: action.payload.regETLId,
          navigation: {
            ...state.formDataValue.RNRR.navigation,
            textValues: {
              ...state.formDataValue.RNRR.navigation.textValues,
              currentRecord: currentIndex + 1,
            },
          },
        },
      },
    };
  },
  [SET_ID_REVIEWED_SUCCESS]: (state, action) => {
    const iderInfo = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RNRR: {
          ...state.formDataValue.RNRR,
          iderReviewedInfo: matchIderInfo(iderInfo),
        },
      },
    };
  },
  [GET_REGETL_KEYWORDS_SUCCESS]: (state, action) => {
    const keywordHits = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RNRR: {
          ...state.formDataValue.RNRR,
          recordKeywordHits: matchKeywordHits(keywordHits),
        },
      },
    };
  },
  [GET_REGETL_CLIENT_SUBJECTS_SUCCESS]: (state, action) => {
    const keywordHits = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RNRR: {
          ...state.formDataValue.RNRR,
          recordClientSubjects: matchClientSubjects(keywordHits),
        },
      },
    };
  },
  [GET_HIGHLIGHTED_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_HIGHLIGHTED_DOC_SUCCESS]: (state) => {
    return {
      ...state,
    };
  },
  [GET_HIGHLIGHTED_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [LOAD_TO_NEW_REG_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [LOAD_TO_NEW_REG_SUCCESS]: (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        RNRR: {
          ...state.formDataValue.RNRR,
          recordInfo: {
            ...state.formDataValue.RNRR.recordInfo,
            textValues: {
              ...state.formDataValue.RNRR.recordInfo.textValues,
              regsId: [
                ...state.formDataValue.RNRR.recordInfo.textValues.regsId,
                action.payload.regId,
              ],
            },
          },
        },
      },
    };
  },
  [LOAD_TO_NEW_REG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [SET_TITLE_EDIT]: (state, action) => {
    const title = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RNRR: {
          ...state.formDataValue.RNRR,
          recordInfo: {
            ...state.formDataValue.RNRR.recordInfo,
            textValues: {
              ...state.formDataValue.RNRR.recordInfo.textValues,
              title,
            },
          },
        },
      },
    };
  },
  [CLEAR_FIELD_FOR_NO_RESULTS]: (state) => {
    const query = state.renderData.queriesWithParameters.find(
      (query) => query.QueryId == state.formDataValue.RNRR.queryLine.radio.query
    );

    const {
      parametersSectionSelectables,
      sortParameters,
      sortFields,
      sortDirections,
      filterFields,
    } = populateSortAndSearchParams(query);

    return {
      ...initialState,
      disableEditing: true,
      renderData: {
        ...initialState.renderData,
        queriesWithParameters: state.renderData.queriesWithParameters,
        queries: state.renderData.queries,
        allRegions: state.renderData.allRegions,
        regions: state.renderData.regions,
        regionsList: state.renderData.regionsList,
      },
      formDataValue: {
        RNRR: {
          ...initialState.formDataValue.RNRR,
          queryLine: {
            ...state.formDataValue.RNRR.queryLine,
          },
          parametersSection: {
            ...state.formDataValue.RNRR.parametersSection,
            radio: parametersSectionSelectables,
          },
          sortParameters: {
            radio: sortParameters,
            fields: sortFields,
          },
          sortDirections: {
            radio: sortDirections,
          },
          filterParameters: {
            fields: filterFields,
          },
          settingsLine: {
            ...state.formDataValue.RNRR.settingsLine,
            radio: {
              ...state.formDataValue.RNRR.settingsLine.radio,
              autoAdvance:
                state.formDataValue.RNRR.settingsLine.radio.autoAdvance,
              autoUrl: state.formDataValue.RNRR.settingsLine.radio.autoUrl,
              extraInfoExpanded:
                state.formDataValue.RNRR.settingsLine.radio.extraInfoExpanded,
            },
          },
        },
      },
    };
  },
  [GET_REG_LOAD_OPTIONS_SUCCESS]: (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        regsLoadOptions: action.payload.json,
      },
    };
  },
  [GET_REG_LOAD_OPTIONS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [LOAD_TO_EXISTING_REG_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [LOAD_TO_EXISTING_REG_SUCCESS]: (state, action) => {
    const regsId = [...state.formDataValue.RNRR.recordInfo.textValues.regsId];
    if (!regsId.find((id) => id === action.payload.regId)) {
      regsId.push(action.payload.regId);
    }

    return {
      ...state,
      isFetchingData: false,
      formDataValue: {
        ...state.formDataValue,
        RNRR: {
          ...state.formDataValue.RNRR,
          recordInfo: {
            ...state.formDataValue.RNRR.recordInfo,
            textValues: {
              ...state.formDataValue.RNRR.recordInfo.textValues,
              regsId,
            },
          },
        },
      },
    };
  },
  [LOAD_TO_EXISTING_REG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_REGETL_REG_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_REGETL_REG_SUCCESS]: (state) => {
    return {
      ...state,
      isFetchingData: false,
    };
  },
  [GET_REGETL_REG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_REGETL_CITATIONMATCH_SUCCESS]: (state, action) => {
    const matchedRegs = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        RNRR: {
          ...state.formDataValue.RNRR,
          recordSimilarRegs: matchSimilarRegs(matchedRegs),
        },
      },
    };
  },
  [GET_REGETL_CITATIONMATCH_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
};
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  isFetchingData: false,
  renderData: {
    queryRecords: [],
    currentRecord: {},
    recordIndex: 0,
    regsLoadOptions: {},
  },
  formDataValue: {
    RNRR: {
      settingsLine: {
        radio: {
          autoAdvance: true,
          autoUrl: false,
          extraInfoExpanded: false,
        },
        textValues: {
          regsId: "",
        },
      },
      queryLine: {
        radio: {
          query: "Select Query",
        },
        textValues: {
          keywordSearch: "",
        },
        selected: [],
      },
      parametersSection: {
        textValues: {},
        dateTime: {},
        radio: [],
      },
      sortParameters: {
        radio: [],
        fields: [],
      },
      sortDirections: {
        radio: [],
      },
      filterParameters: {
        fields: [],
      },
      navigation: {
        textValues: {
          currentRecord: "1",
        },
      },
      reviewRecords: matchReviewRows([]),
      recordInfo: matchRecordInfo({ Tags: [], RelatedRegs: [] }),
      iderReviewedInfo: matchIderInfo({}),
      recordKeywordHits: matchKeywordHits([]),
      recordClientSubjects: matchClientSubjects([]),
      recordSimilarRegs: matchSimilarRegs([]),
      otherDocs: {
        0: {
          textValues: {
            urlIdDocs: "",
            urlDescription: "",
          },
          radio: {
            docsType: "versions",
          },
        },
      },
      clients: {
        selected: [],
      },
      notLoadedClients: {
        selected: [],
      },
      history: {
        textValues: {
          history: "",
        },
      },
    },
  },
};

export default function regsNewRecordReviewReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/regsNewRecordReviewFormData.js